import {
  Box,
  Typography,
  CircularProgress
} from '@mui/material'
import clsx from 'clsx'
import { useStyles } from './CheckinModal.styles'

export const ProcessingPanel = () => {
  const { classes } = useStyles()
  return (
    <Box className={clsx(classes.dialogBox, classes.dialogPanel)}>
      <Typography className={clsx(classes.label)}>Processing Check-In...</Typography>
      <CircularProgress className={clsx(classes.progress)} />
    </Box>
  )
}
